import { gql } from "@apollo/client";

export const PICKUP_TASK_APPOINTMENT_FIELDS = gql`
  fragment PickupTaskAppointmentFields on PickupTaskAppointmentWithAddressType {
    id
    sequence
    site
    zipcode
    addressLine1
    addressLine2
    country
    state
    city
    quantity
    unit
    appointmentTime
    actualQuantity
    actualUnit
    actualTime
    businessHours
    businessDays
    status
    contactName
    contactPhone
    ext
    channelName
    appointmentNumber
    taskId
    warehouseId
    cooperationWarehouseId
    isFinished
    isAbnormal
    isNewWarehouse
    photosUrls
    exceptionPhotosUrls
    unloadingTime
    actualPickupTime
    exceptionReasonCode
    unloadingPhotosUrls
    actCompleteTime
    remark
    latitude
    longitude
    hasLinkedPickupOrder
  }
`;

export interface PickupAppointmentType {
  id: string;
  sequence: number;
  site: string;
  zipcode: string;
  addressLine1: string;
  addressLine2?: string;
  country?: string;
  state?: string;
  city?: string;
  quantity: number;
  unit: string;
  appointmentTime: string;
  actualQuantity: number;
  actualUnit: string;
  actualTime: string;
  businessHours: string;
  businessDays: number[];
  status: string;
  contactName: string;
  contactPhone: string;
  ext: string;
  channelName: string;
  appointmentNumber?: string;
  taskId: string;
  warehouseId: string;
  cooperationWarehouseId?: string;
  isFinished: boolean;
  isAbnormal: boolean;
  isNew?: boolean;
  isNewWarehouse: boolean;
  photosUrls?: string[];
  exceptionPhotosUrls?: string[];
  unloadingPhotosUrls?: string[];
  unloadingTime: string;
  actualPickupTime: string;
  exceptionReasonCode: string;
  remark: string;
  latitude?: number | null;
  longitude?: number | null;
  hasLinkedPickupOrder: boolean;
}